import { render, staticRenderFns } from "./ed-generic-calendar.component.vue?vue&type=template&id=68ad1960&scoped=true&"
import script from "./ed-generic-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-generic-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-generic-calendar.component.scss?vue&type=style&index=0&id=68ad1960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad1960",
  null
  
)

export default component.exports